const analyzeStatusOptions = [
  { value: "pending", label: "Do weryfikacji" },
  { value: "inProgress", label: "W trakcie analizy" },
  { value: "completed", label: "Przeanalizowana" },
  { value: "canceled", label: "Odrzucona" },
];
export default analyzeStatusOptions;
